import CheckBoxInput from 'components/elements/inputs/check-box-input';
import {
  isCheckedCheckboxTable,
  isIndeterminateCheckboxTable,
} from 'components/elements/table/utils';
import { useFormContext, useWatch } from 'react-hook-form';

import { FlightScheduleFormType } from './flight-schedule-form-type';

const name = 'flightSchedules' as const;

export default function FlightScheduleCheckboxHeader() {
  const { control, setValue } = useFormContext<FlightScheduleFormType>();
  const flightSchedules = useWatch({
    name,
    control,
  });
  const isIndeterminate = isIndeterminateCheckboxTable({
    type: 'state',
    data: flightSchedules,
    isCheck(data) {
      return data.isCheck;
    },
  });

  const checked = isCheckedCheckboxTable({
    type: 'state',
    data: flightSchedules,
    isCheck(data) {
      return data.isCheck;
    },
  });

  return (
    <CheckBoxInput
      checked={checked}
      isIndeterminate={isIndeterminate}
      onChange={(e) => {
        const checked = e.currentTarget.checked;
        const schedules = flightSchedules.map((schedule) => {
          return {
            ...schedule,
            isCheck: checked,
          };
        });
        setValue(name, schedules, {
          shouldTouch: true,
          shouldValidate: true,
        });
      }}
    />
  );
}
